import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider } from 'notistack';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

// custom componentes
import App from './App';
import Context from './context';
import AuthProvider from 'context/auth';
import store from 'redux/store';
import notistackConfig from 'pages/Notifier/notistackConfig';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <AuthProvider>
          <Context>
            <SnackbarProvider {...notistackConfig}>
              <App />
            </SnackbarProvider>
          </Context>
        </AuthProvider>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
